module.exports = __webpack_public_path__ + "static/img/首页loading.3505d2c2.png";